import { useQuery } from '@tanstack/react-query';
import { useHybridAuth } from './useHybridAuth';
import { QueryConfig } from '../api/client';
import { driverApi } from '../services/driverApi';

const getReleasedImpoundsCount = async (
  token: string,
  companyId?: string
): Promise<number> => {
  console.log(
    '🚛 [useReleasedImpoundsCount] Setting auth token and calling API'
  );
  driverApi.setAuthToken(token);

  // Get driver profile to get company ID if not provided
  if (!companyId) {
    const driverProfile = await driverApi.getProfile();
    companyId = driverProfile.companyId;
    console.log(
      '🚛 [useReleasedImpoundsCount] Got company ID from driver profile:',
      companyId
    );
  }

  const result = await driverApi.getReleasedImpoundsCount(companyId);
  console.log('🚛 [useReleasedImpoundsCount] Hook received result:', result);
  return result;
};

export const useReleasedImpoundsCount = (
  config?: QueryConfig<typeof getReleasedImpoundsCount>
) => {
  const { getAccessTokenSilently, isAuthenticated } = useHybridAuth();

  return useQuery({
    ...config,
    queryFn: async () => {
      const token = await getAccessTokenSilently();
      return getReleasedImpoundsCount(token);
    },
    queryKey: ['released-impounds-count'],
    enabled: isAuthenticated,
    staleTime: 5 * 60 * 1000, // 5 minutes - less critical than active impounds
    refetchInterval: 10 * 60 * 1000, // Refetch every 10 minutes
  });
};
